import { PostClosingTabsEnum } from '../constants/tabs';

export const getPostClosingActionHandlers = ({
  selectedRows,
  tabValue,
  excelDashboard,
  openLoanActionModal,
  openLoanDateModal,
  openLoanNumberModal,
  exportDashboardService,
  setNotification,
  openLoanSpecialistModal,
}) => {
  const handlers = {
    onDashboardExport: async () => {
      const loanProcess =
        tabValue === PostClosingTabsEnum.COLLATERAL_MANAGEMENT
          ? 'Post Closing Collateral Management'
          : 'Post Closing Trailing Documents';

      try {
        const response = await exportDashboardService(loanProcess, '');

        const fileName =
          tabValue === PostClosingTabsEnum.COLLATERAL_MANAGEMENT
            ? 'Collateral Management Dashboard.xlsx'
            : 'Trailing Documents Dashboard.xlsx';

        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (e) {
        console.error('Export error:', e);
        setNotification?.('Error exporting data');
      }
    },

    originalDocReceived: () =>
      openLoanActionModal({
        title: 'Confirm Original Loan Doc Received',
        fieldKey: 'loan_docs_receieved',
        loans: selectedRows,
      }),

    isEfileCompleted: () =>
      openLoanActionModal({
        title: 'Confirm E-File Completed',
        fieldKey: 'is_efile_completed',
        loans: selectedRows,
      }),

    custodial: () =>
      openLoanActionModal({
        title: 'Confirm Custodial Flag',
        fieldKey: 'is_custodial',
        loans: selectedRows,
      }),

    custodialShipDate: () =>
      openLoanDateModal({
        title: 'Set Custodial Ship Date',
        fieldKey: 'loan_custodian_ship_date',
        loans: selectedRows,
      }),

    custodialTrackingNumber: () =>
      openLoanNumberModal({
        title: 'Set Custodial Tracking Number',
        fieldKey: 'loan_custodian_tracking_number',
        loans: selectedRows,
      }),

    updatePostClosingSpecialist: () =>
      openLoanSpecialistModal({
        title: 'Reassign Specialist',
        loans: selectedRows,
      }),
  };

  return handlers;
};
